import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export default async function ExportToPDF (navigateWay) {
    const siteDH = navigateWay.room.split('/')[2] + " - " + navigateWay.rack.split('/')[3]
    const boardElement = document.getElementById("board-container");
  
    if (!boardElement) {
        console.error("Tabuleiro não encontrado!");
        return;
    }
  
    try {
        // Captura o conteúdo completo do elemento como imagem
        const canvas = await html2canvas(boardElement, {
            scrollX: 0,
            scrollY: 0,
            useCORS: true, // Permite capturar imagens externas
            scale: 2, // Aumenta a resolução da imagem
        });
  
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = canvas.width; // Largura da imagem em pixels
        const imgHeight = canvas.height; // Altura da imagem em pixels
  
        // Conversão para milímetros (1 pixel = 0.264583 mm)
        const pdfWidth = imgWidth * 0.264583;
        const pdfHeight = imgHeight * 0.264583;
  
        // Cria o PDF com dimensões automáticas
        const pdf = new jsPDF({
            orientation: pdfWidth > pdfHeight ? "landscape" : "portrait",
            unit: "mm",
            format: [pdfWidth, pdfHeight],
        });
  
        // Adiciona a imagem ao PDF
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
  
        // Salva o PDF
        pdf.save(`RackCount RoomMap ${siteDH}.pdf`);
    } catch (error) {
        console.error("Erro ao gerar PDF:", error);
    }
  };